import { Checkbox } from "flowbite-react";

const CheckboxCard = ({ id, name, onChange, children }) => {
  return (
    <div className="flex items-center h-12 gap-3 px-4 bg-body rounded-5">
      <Checkbox
        id={id}
        name={name}
        onChange={onChange}
      />
      <label
        htmlFor={id}
        className="flex font-default text-dark-text"
      >
        {children}
      </label>
    </div>
  )
}

export default CheckboxCard;